module.exports = __webpack_public_path__ + "static/media/guardian.7c5d3af5.png";